import * as Yup from "yup";
const createProjectValidationSchema = Yup.object({
  name: Yup.string().required("Project title is required"),
  location: Yup.string().required("Project location is required"),
  summary: Yup.string().required("Project summary is required"),
  project_category: Yup.array().required("Project category is required"),
  projected_impact: Yup.number().required("Project impact is required"),
  fundraising_goal: Yup.string().required("Fundraising goal is required"),
  impact_of_monetary_goal: Yup.string().required(
    "Impact of monetary goal is required"
  ),
  impact_of_donated_item: Yup.string().required(
    "Donated item impact is required"
  ),
  items_donation: Yup.array().required("Items donation is required"),
});

export { createProjectValidationSchema };
